module.exports = __webpack_public_path__ + "img/2.f86923d7.png";